import { useState, useEffect } from 'react';

// Custom hook to fetch and return the general access type. General accesstype can be set in Bold: Asetukset -> Configure -> Access Control
// you can see that value in /api/v1/config endpoint as "access-level-values"
// first value from array is used for general access type.
// "2" - "public" (all stories are public)
// "3" - "login" (all subscription/null stories are login)
// "4" - all users whitelisted, code change in app.js file
// not "2" or "3" or "4" - "not set" (use the story's own access type)
const useGeneralAccessType = (initialAccessType) => {
  const [accessType, setAccessType] = useState(initialAccessType);

  useEffect(() => {
    const fetchGeneralAccessTypeData = async () => {
      try {
        const response = await fetch(`/api/v1/config`);
        const data = await response.json();
        const fetchedGeneralAccessType = data["access-level-values"][0] || 1;

        // If generalAccessType is "2", set accessType to "public"
        if (fetchedGeneralAccessType === "2") {
          setAccessType("public");

        // If generalAccessType is "3" and accessType is either "subscription" or null, set accessType to "login"
        } else if (fetchedGeneralAccessType === "3" && (initialAccessType === "subscription" || initialAccessType === null)) {
          setAccessType("login");

          // If generalAccessType is not "2" or "3", use the story's own access type
        } else {
          setAccessType(initialAccessType);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchGeneralAccessTypeData();
  }, [initialAccessType]);

  return accessType;
};

export default useGeneralAccessType;
